<div [tslSpinner]="loading" class="channel-onboarding">
    <h3 i18n="@@EInvoicingNecessaryInformation" t="EInvoicingNecessaryInformation">Please fill out the necessary information. Tesla will review the request before activating the channel.</h3>
    <hr class="divider" />
    <div class="content">
        <div class="container">
            <div class="flex-items">
                <tsl-icon class="warning">warning</tsl-icon>
            </div>
            <div class="flex-items">
                <p i18n="@@SubmitInvoicesThroughTheSelectedChannel" t="SubmitInvoicesThroughTheSelectedChannel">
                    Please remember that once this selection is done you can only submit your invoices corresponding to production Purchase Orders through the selected channel.
                </p>
            </div>
        </div>
        <div class="create-channel-request">
            <div class="channel-request-content">
                <form class="channel-form" [formGroup]="createChannelRequestFormGroup" (ngSubmit)="onSubmit()">
                    <div class="channel-form-info">
                        <div clss="form-section">
                            <div class="row">
                                <span i18n="@@EInvoicingSelectEntities" t="EInvoicingSelectEntities">1. Select the entities you would like to onboard to the selected channels. Multiple entities can only be from same region.</span>
                            </div>
                            <div class="row">
                                <tsl-form-field class="channel-form-field col-sm-4">
                                    <tsl-label i18n="@@8650097416683280767" t="8650097416683280767">Region</tsl-label>
                                    <tsl-select
                                        #regionSelect
                                        formControlName="region"
                                        required
                                        (selectionChange)="onRegionChange($event)"
                                        style="z-index: 100005"
                                    >
                                        <tsl-option
                                            #regionOptions
                                            *ngFor="let region of filteredRegions"
                                            [value]="region"
                                            style="z-index: 100005"
                                        >
                                            {{ region }}
                                        </tsl-option>
                                    </tsl-select>
                                </tsl-form-field>
                                <tsl-form-field class="channel-form-field col-sm-4">
                                    <tsl-label i18n="@@7693952740891603217" t="7693952740891603217">Entity</tsl-label>
                                    <tsl-select
                                        formControlName="entity"
                                        required
                                        (selectionChange)="onEntityChange($event)"
                                    >
                                        <tsl-option
                                            #entityOptions
                                            *ngFor="let entity of filteredEntities"
                                            [value]="entity"
                                        >
                                            {{ entity }}
                                        </tsl-option>
                                    </tsl-select>
                                </tsl-form-field>
                            </div>
                        </div>
                        <div class="form-section">
                            <div class="row">
                                <span i18n="@@EInvoicingSelectChannel" t="EInvoicingSelectChannel">2. Please select the channel that best fit your business need.</span></div>
                            <tsl-form-field class="channel-form-field col-sm-4">
                                <tsl-label i18n="@@708415056994995740" t="708415056994995740">E-Invoicing Channel</tsl-label>
                                <tsl-select
                                    formControlName="channel"
                                    required
                                    (selectionChange)="onChannelChange($event)"
                                    placeholder="Please first select a region/entity"
                                    tPlaceholder="PleaseFirstSelectARegionEntity"
                                    i18n-placeholder="@@PleaseFirstSelectARegionEntity"
                                    [disabled]="isChannelSelection"
                                >
                                    <tsl-option *ngFor="let channel of currentChannelOptions" [value]="channel">
                                        {{ channel }}
                                    </tsl-option>
                                </tsl-select>
                            </tsl-form-field>
                            <tsl-error class="col-sm-12 text-left show-error">
                                <span *ngIf="selectionMessage">{{translate.get(selectionMessage)}}</span>
                            </tsl-error>
                        </div>
                        <div class="form-section">
                            <div *ngIf="isEDISelected">
                                <div class="row channel-form-field">
                                    <span i18n="@@EDISetup" t="EDISetup">EDI Setup</span>
                                </div>
                                <div class="row">
                                    <tsl-form-field
                                        [formcontrol]="ediQualifierProd"
                                        class="channel-form-field col-sm-4"
                                    >
                                        <tsl-label i18n="@@3165893924627602712" t="3165893924627602712">Qualifier/DUNS ID (Production)</tsl-label>
                                        <input
                                            tslInput
                                            fullWidth
                                            maxlength="50"
                                            shape="round"
                                            [formControl]="ediQualifierProd"
                                            placeholder="Qualifier/DUNS ID (Production)"
                                            tPlaceholder="3165893924627602712" i18n-placeholder="@@3165893924627602712"
                                            readonly
                                        />
                                    </tsl-form-field>
                                    <tsl-form-field
                                        [formcontrol]="ediQualifierTest"
                                        class="channel-form-field col-sm-4"
                                    >
                                        <tsl-label i18n="@@3634089327962275265" t="3634089327962275265">Qualifier/DUNS ID (Test)</tsl-label>
                                        <input
                                            tslInput
                                            fullWidth
                                            maxlength="50"
                                            shape="round"
                                            [formControl]="ediQualifierTest"
                                            placeholder="Qualifier/DUNS ID (Test)"
                                            tPlaceholder="3634089327962275265" i18n-placeholder="@@3634089327962275265"
                                            readonly
                                        />
                                    </tsl-form-field>
                                </div>
                                <div class="row">
                                    <tsl-form-field [formcontrol]="ediVanProvider" class="channel-form-field col-sm-4">
                                        <tsl-label i18n="@@720795693816819642" t="720795693816819642">VAN Provider</tsl-label>
                                        <input
                                            tslInput
                                            fullWidth
                                            maxlength="50"
                                            shape="round"
                                            [formControl]="ediVanProvider"
                                            placeholder="VAN Provider"
                                            tPlaceholder="720795693816819642" i18n-placeholder="@@720795693816819642"
                                            readonly
                                        />
                                    </tsl-form-field>
                                    <tsl-form-field [formcontrol]="ediBusCont" class="channel-form-field col-sm-4">
                                        <tsl-label i18n="@@9043742488068808431" t="9043742488068808431">Business Contact Email within Tesla</tsl-label>
                                        <input
                                            tslInput
                                            fullWidth
                                            maxlength="50"
                                            shape="round"
                                            [formControl]="ediBusCont"
                                            placeholder="Business Contact Email within Tesla"
                                            tPlaceholder="9043742488068808431" i18n-placeholder="@@9043742488068808431"
                                            readonly
                                        />
                                    </tsl-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="form-section">
                            <div class="row" *ngIf="this.channelSelection?.value != 'SelfBilling'; else selfBilling">
                              <span i18n="@@DownloadEInvocingTemplates" t="DownloadEInvocingTemplates">3. Download the templates and upload the filled out versions.</span>
                            </div>
                            <ng-template #selfBilling class="row">
                                <span i18n="@@DownloadEInvocingSelfBillingTemplates" t="DownloadEInvocingSelfBillingTemplates">3. Download the EDI templates that Tesla will send as 810 EDI.</span>
                            </ng-template>
                            <div *ngFor="let documents of selectedChannelTemplate">
                                <button
                                    id="btn-inv-excel-export"
                                    tsl-button
                                    color="black"
                                    shape="round"
                                    appearance="ghost"
                                    size="medium"
                                    [disabled]="!channelSelected"
                                    (click)="downlodChannelTemplates(documents.documentID, documents.fileName)"
                                >
                                    <tsl-icon>file_download</tsl-icon>
                                    <span i18n="Button label to downlod channel templates">
                                        {{ documents.fileName }}
                                    </span>
                                    <tsl-error *ngIf="allowDownload" class="text-left">
                                        {{allowDownloadError}}
                                    </tsl-error>
                                </button>
                            </div>
                          <div class="row" *ngIf="!this.channelSelection || this.channelSelection.value != 'SelfBilling'">
                                <div class="col-5">
                                    <tsl-label i18n="@@UploadFilledDocument" t="UploadFilledDocument">Upload Filled Document: *</tsl-label>
                                    <ul>
                                        <li i18n="@@UploadMaxOf5Files" t="UploadMaxOf5Files">You can only upload max of 5 files</li>
                                        <li i18n="@@RequireFiletype" t="RequireFiletype" [tParams]="[requiredFileType]" *ngIf="this.channelSelection.value">Required file type : {{requiredFileType}} (.pdf optional)</li>
                                        <li i18n="@@AllowedFileTypes" t="AllowedFileTypes">You can upload additional supporting documents with the following file types: .txt, .pdf, .csv, .xml</li>
                                        <li><b i18n="@@FileUploadRequired" t="FileUploadRequired">File upload is required</b></li>
                                    </ul>
                                    <tsl-file-drop
                                        [inputText]="translate.get('choose a file')" [hintText]="translate.get('Drag and Drop a File or ')"
                                        #fileDrop
                                        [accept]="getAcceptedFormat"
                                        (fileChange)="onFileAdd($event)"
                                        [disabled]="loadedFiles?.length >= 5"
                                        required
                                    ></tsl-file-drop>
                                    <button tsl-button color="black" outline (click)="resetFiles()" i18n="@@ResetFile" t="ResetFile">Reset File</button>
                                </div>
                                <div class="col-7">
                                    <tsl-label i18n="@@5164612682352952480" t="5164612682352952480">Uploaded Files:</tsl-label>
                                    <table *ngIf="loadedFiles.length" class="tsl-table file-list table">
                                        <thead>
                                            <tr class="tsl-header-row">
                                                <th class="tsl-header-cell" style="width: 600px" i18n="@@Name" t="Name">Name</th>
                                                <th class="tsl-header-cell" style="width: 200px" i18n="@@Actions" t="Actions">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tsl-row" *ngFor="let file of loadedFiles; index as idx">
                                                <td class="tsl-cell" style="width: 600px">{{ file.name }}</td>
                                                <td class="tsl-cell" style="width: 200px">
                                                    <button (click)="removeFile(idx)" tsl-icon-button>
                                                        <tsl-icon>delete</tsl-icon>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="no-files-msg row" *ngIf="!loadedFiles.length">
                                        <span i18n="@@NoFilesSelected" t="NoFilesSelected">No Files Selected.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                      <div class="form-section" *ngIf="showValidationErrors">
                        <tsl-alert status="error">
                          <h4 i18n="@@ValidationErrorsTitle" t="ValidationErrorsTitle">CXML Validation Errors</h4>
                          <div *ngFor="let error of validationErrors" class="validation-error-item">
                            <strong>{{ error.fileName }}</strong>
                            <ul>
                              <ng-container [ngSwitch]="error.isAmbiguousError">
                                <ng-container *ngSwitchCase="true">
                                  <li>
                                    Your .xml test file does not meet the formatting requirements.
                                    Please review the sample file/template and work with your IT team (as needed) to submit a corrected .xml file to continue testing.<br>
                                    <strong>NOTE:</strong> If you do not wish to continue cXML testing/onboarding, please submit your invoice(s) using
                                    the <a [href]="createInvoiceFromPOUrl">Create Invoice from PO</a> portal page. All
                                    invoicing training guides are found on the <a [href]="guidelineUrl">Documents & Guidelines</a> portal page.
                                  </li>
                                </ng-container>
                                <ng-container *ngSwitchCase="false">
                                  <li *ngFor="let message of error.errorMessages">{{ message }}</li>
                                </ng-container>
                              </ng-container>
                            </ul>
                          </div>
                        </tsl-alert>
                      </div>

                        <div class="form-section">
                            <tsl-form-field class="col-7 comment-area w-100">
                                <tsl-label i18n="@@7428545052950207291" t="7428545052950207291">Comments *</tsl-label>
                                <textarea
                                    tslInput
                                    formControlName="comments"
                                    fullWidth="true"
                                    maxlength="250"
                                    shape="round"
                                    tPlaceholder="8451621568903155465" i18n-placeholder="@@8451621568903155465"
                                    placeholder="Please provide comments."
                                    rows="5"
                                    style="resize:none;"
                                ></textarea>
                                <tsl-hint align="below" class="max-length-hint"
                                    >{{ comments.value?.length || 0 }} / 250</tsl-hint
                                >
                            </tsl-form-field>
                        </div>
                        <div class="row channel-form-field" #edi *ngIf="this.channelSelection?.value == 'EDI' || this.channelSelection?.value == 'SelfBilling'">
                            <tsl-label i18n="@@EDISupport" t="EDISupport">Please reach out to EDI support if you have any questions - TeslaEDI@tesla.com.</tsl-label>
                        </div>
                        <div *ngIf="this.channelSelection?.value == 'SelfBilling'" class="form-section">
                            <tsl-checkbox (change)="onSupplierConfirmationSelfBillingChange($event)">
                                <span i18n="@@EInvoicingCheckBox" t="EInvoicingCheckBox">Clicking this checkbox confirms that the edi setup for the templates provided by Tesla has been completed.</span>
                            </tsl-checkbox>
                        </div>
                        <div class="form-section">
                            <div class="col right">
                                <button
                                    tsl-button
                                    color="blue"
                                    type="submit"
                                    [disabled]="isValidating || createChannelRequestFormGroup.status == 'INVALID' || (this.loadedFiles?.length <= 0 && this.channelSelection?.value != 'SelfBilling') || (this.channelSelection?.value == 'SelfBilling' && !this.supplierConfirmation)"
                                    i18n="@@SubmitRequest"
                                    t="SubmitRequest"
                                    >
                                    <span >Submit Request</span>
                                    <span *ngIf="isValidating">Validating...</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
